import { IPlansResponseRaw } from 'models/lead.model'
import { subscriptionsApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const fetchPlans = async (cohortLeadId: string): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_PLANS)

  const response = await subscriptionsApi.getPlans({
    cohortLeadId,
  })

  if (response?.data && response?.success) {
    const responsePlans: IPlansResponseRaw = response.data

    useZustandStore.setState({
      cohortLeadPlans: responsePlans.plans,
      cohortLeadCurrency: responsePlans.currency,
    })
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_PLANS)
}
